<template>
  <vue-modal id="ownReservationModal"
             classes="vue-modal-container"
             height="auto"
             name="own-reservation-modal"
             width="360px">
    <div class="header">
      <h3>{{ trans.header }}</h3>
      <button class="close-modal"
              @click="$modal.hide('own-reservation-modal')">
        <i class="close icon"/>
      </button>
    </div>
    <div :set="(clubInfo = pfClientActive ? partnersAt(startTime) : {})"
         class="content">
      <p>{{ trans.subject }}: {{ subjectTypeName }} {{ subjectName }}</p>
      <p>{{ trans.date }}: {{ startTime }}</p>
      <p v-if="show_reservation_code">{{ trans.reservationCode }}: <strong>{{ reservationCode }}</strong></p>
      <div v-if="extraOptions && extraOptions.length > 0"
           class="extra-options-container">
        <h5 class="subheader">{{ trans.extraOptionsSubHeader }}</h5>
        <timetable-extra-options :extra-options="extraOptions"
                                 :is-editable="false"/>
      </div>
      <partner-finder-extra v-if="pfClientActive"
                            :clubInfo="clubInfo"
                            :from_time="startTime"
                            :subject_id="subjectId"/>
    </div>
    <div class="actions">
      <div class="ui negative approve button"
           @click="resign()">{{ trans.resignBtnText }}
      </div>
      <div class="ui cancel button"
           @click="$modal.hide('own-reservation-modal')">{{ trans.cancelBtnText }}
      </div>
    </div>
  </vue-modal>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import TimetableExtraOptions from '@/components/components/TimetableExtraOptions';
import PartnerFinderExtra from '@/components/partnerFinder/PartnerFinderExtra';
import {pfGetClientActive, pfGetPartnersAt} from '../../store/partnerFinder';


export default {
  props: ['startTime', 'timeTableId', 'subjectId', 'subjectName', 'subjectTypeName', 'extraOptions', 'reservationCode'],
  methods: {
    resign () {
      this.$parent.$emit('resign-reservation', this.timeTableId)
      this.$modal.hide('own-reservation-modal')
    },
  },
  computed: {
    ...mapState({
      trans: state => state.trans.ownReservationModal,
    }),
    ...mapGetters({
      pfClientActive: pfGetClientActive,
      partnersAt: pfGetPartnersAt,
    }),
    show_reservation_code() {
      const clients = this.$store.state.clients
      const currentClientDomain = this.$store.state.currentClientDomain
      for (let client of clients) {
        if (client?.domain === currentClientDomain) {
          return !!client.config?.show_reservation_code
        }
      }
      return false
    },    
  },
  components: {
    TimetableExtraOptions,
    PartnerFinderExtra,
  },
}
</script>
